import React, { ReactElement } from "react";
import {
  TradeInputsWithoutSymbol,
  ComponentProps,
  TradeType,
  DurationOptions,
  ExtraTradeFields,
} from ".";
import { EquityTradeInputs } from "$gql/types.gen";
import { formatCurrency } from "@tiicker/util/lib/formats";
import FormInput from "components/Form/FormInput";
import DropDownSelect from "components/core/Forms/DropDownSelect/DropDownSelect";

export type StopLimitBuyFields = Pick<
  EquityTradeInputs,
  "quantity" | "stop" | "price" | "duration"
> &
  ExtraTradeFields;

const BuildOrder = (data: StopLimitBuyFields): TradeInputsWithoutSymbol => {
  return {
    duration: data.duration,
    quantity: data.quantity,
    side: "buy",
    type: "stop_limit",
    price: data.price,
    stop: data.stop,

    clientOrderId: data.clientOrderId,
    previewId: data.previewId,
  };
};

const Component = (props: ComponentProps<StopLimitBuyFields>): ReactElement => {
  const { errors, control } = props.form;

  return (
    <>
      <FormInput
        type="number"
        ref={props.form.register}
        name="stop"
        label="Stop Price"
        min={0}
        // formatter={(value) => {
        //   if (typeof value === "string" && value.length === 0) {
        //     return value;
        //   }

        //   return `$${value}`;
        // }}
        placeholder={formatCurrency(0)}
        step={0.01}
        required={true}
        error={errors.stop && errors.stop.message}
        displayOptions={{ inline: true, hideRequiredIndicator: true }}
      />

      <FormInput
        type="number"
        ref={props.form.register}
        name="price"
        label="Limit Price"
        min={0}
        // formatter={(value) => {
        //   if (typeof value === "string" && value.length === 0) {
        //     return value;
        //   }

        //   return `$${value}`;
        // }}
        placeholder={formatCurrency(0)}
        step={0.01}
        required={true}
        error={errors.price && errors.price.message}
        displayOptions={{ inline: true, hideRequiredIndicator: true }}
      />

      <DropDownSelect
        register={props.form.register}
        name="duration"
        label="Expires"
        required={true}
        error={errors.duration && errors.duration.message}
        displayOptions={{ inline: true, size: "slim" }}
        options={DurationOptions}
        defaultValue={DurationOptions[0].value as any}
      />
    </>
  );
};

const StopLimitBuy: TradeType<StopLimitBuyFields> = {
  BuildOrder,
  Component,
};

export default StopLimitBuy;
